import React from 'react';
export const CGViewContext = React.createContext( {
  cgv: null,
  loadCGView: () => {},
} );
